import TextField from "@mui/material/TextField";

import { useNitroStore } from "../../store/Store";
import FormField from "../../components/FormField";
import QuotesTable from "./components/QuotesTable";
import FormattedQuoteForm from "./components/FormattedQuoteForm";
import CloseIcon from "../../components/CloseIcon";
import NitroModal from "../../components/Modal";
import ZIndex from "../../styles/zindex";
import { useIsMobile } from "../../hooks/useIsMobile";

import "./index.css";

const QuotesPanel = () => {
  const isMobile = useIsMobile(768);
  const [showQuotesPanel, setShowQuotesPanel] = useNitroStore((state) => [
    state.showQuotesPanel,
    state.setShowQuotesPanel,
  ]);

  return (
    <NitroModal
      id="QuotesPanel"
      className="quotesPanel"
      open={showQuotesPanel}
      style={{
        zIndex: ZIndex.QuotesPanel,
      }}
    >
      <div
        style={{
          marginTop: 90,
          backgroundColor: "white",
          width: isMobile ? "100%" : 600,
          maxWidth: isMobile ? "100%" : 600,
          display: "flex",
          flexDirection: "column",
          boxShadow:
            "-6px 8px 23px 0px #0000001A, -25px 33px 42px 0px #00000017, -57px 74px 56px 0px #0000000D, -101px 132px 67px 0px #00000003, -158px 206px 73px 0px #00000000",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            height: 108,
            backgroundColor: "#F2F8FD",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingLeft: 32,
            paddingRight: 32,
          }}
        >
          <div
            style={{
              color: "#0F2C52",
              fontSize: 32,
              fontWeight: 700,
            }}
          >
            Quote
          </div>

          <div style={{ display: "flex", gap: 4 }}>
            <CloseIcon onClick={() => setShowQuotesPanel(false)} />
          </div>
        </div>
        {/* END HEADER */}

        {/* BODY */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 20,
            padding: "10px 20px",
            minHeight: 0,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <QuotesTable />

          <div style={{ color: "#231F20", fontWeight: 700, fontSize: 16 }}>
            Palmyra, MO
          </div>

          <div style={{ display: "flex", gap: 30 }}>
            {/* COLUMN 1 */}
            <div
              style={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                gap: 15,
              }}
            >
              <div
                style={{
                  color: "#148DD3",
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: "uppercase",
                }}
              >
                Quote Details
              </div>
              <div
                style={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: 20,
                }}
              >
                <FormField label="Quantity">
                  <TextField fullWidth size="medium" />
                </FormField>
                <FormField label="UOM">
                  <TextField fullWidth size="medium" />
                </FormField>

                <FormField label="Title transfer">
                  <TextField fullWidth size="medium" />
                </FormField>

                <FormField label="Ship window">
                  <div style={{ display: "flex", gap: 10 }}>
                    <TextField fullWidth value="01/01/2024" size="medium" />
                    <TextField fullWidth value="05/01/2024" size="medium" />
                  </div>
                </FormField>

                <FormField
                  label={
                    <div
                      style={{ display: "flex", gap: 4, alignItems: "center" }}
                    >
                      Comments <div style={{ fontWeight: 400 }}>(optional)</div>
                    </div>
                  }
                >
                  <TextField fullWidth multiline rows={3} />
                </FormField>
              </div>
            </div>

            {/* COLUMN 2 */}
            <div
              style={{
                width: "60%",
                display: "flex",
                flexDirection: "column",
                gap: 20,
              }}
            >
              <div
                style={{
                  color: "#148DD3",
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: "uppercase",
                }}
              >
                Formatted Quotes
              </div>

              {/* QUOTE FORM */}
              <FormattedQuoteForm />
              {/* END QUOTE FORM */}
            </div>
          </div>
        </div>
        {/* END BODY */}
      </div>
    </NitroModal>
  );
};

export default QuotesPanel;
